const apostrophe = {
  'family members': 'family member\'s',
  caregivers: 'caregiver\'s',
  parents: 'parent\'s',
  'parents and caregivers': 'parents and caregiver\'s',
  'health providers': 'health provider\'s',
  educators: 'educator\'s',
  'community leaders': 'community leader\'s',
  'community members': 'community member\'s',
  volunteers: 'volunteer\'s',
  beneficiaries: 'beneficiary\'s',
  clients: 'client\'s',
  'program participants': 'program participant\'s',
  students: 'student\'s',
  youth: 'youth\'s',
  'low-income workers': 'low-income worker\'s',
  'at-Risk Youth': 'at-Risk youth\'s',
  'underserved people': 'underserved people\'s',
  families: 'family\'s',
  animals: 'animal\'s',
};

export const getBeneficiaryWithApostrophe = (beneficiaryName?: string) => {
  if (!beneficiaryName) return beneficiaryName;
  return apostrophe[beneficiaryName.toLowerCase()] || beneficiaryName;
};
